import { render } from "./Logo.vue?vue&type=template&id=7b7bdcd4"
const script = {}
script.render = render

export default script